export default "__VITE_ASSET__BOcGK5Xu__"